var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrintCmr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#3B66B0;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14,15.5h1.4V14H14V15.5z M14,12.6h1.4v-1.4H14V12.6z M13.3,23.3c-0.4,0-0.7-0.1-1-0.4c-0.3-0.3-0.4-0.6-0.4-1 V10.5c0-0.4,0.1-0.7,0.4-1s0.6-0.4,1-0.4H19l4.3,4.3v8.5c0,0.4-0.1,0.7-0.4,1c-0.3,0.3-0.6,0.4-1,0.4H13.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 5.1,
    y: 0.9,
    className: "st0",
    width: 12.4,
    height: 4.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.6,19.5v-2.1H7.1v-4.1h3.4V9.2c0-0.5,0.2-0.9,0.5-1.2c0.3-0.3,0.8-0.5,1.2-0.5h7l2.3,2.3V9.2 c0-0.9-0.3-1.6-0.9-2.2c-0.6-0.6-1.3-0.9-2.2-0.9H4C3.2,6.1,2.4,6.4,1.8,7C1.2,7.6,0.9,8.3,0.9,9.2v6.2h4.1v4.1H10.6z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrintCmr);
export default __webpack_public_path__ + "static/media/print-cmr.5f4d20a2470262ddf9544d1a715f108a.svg";
export { ForwardRef as ReactComponent };